{
  "familyId": "MET-HOEK-TEKENEN",
  "questions": [
    {
      "id": "MET-HOEK-TEKENEN-001",
      "familyId": "MET-HOEK-TEKENEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_tekenen",
      "questionType": "multiple_choice",
      "question": "Je wilt een hoek van 60° tekenen. Waar zet je het tweede punt op de geodriehoek?",
      "options": ["Bij de 60° markering", "Bij de 120° markering", "Bij de 30° markering", "Bij de 90° markering"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoek tekenen met geodriehoek",
            "content": "Leg de geodriehoek met het nulpunt op het beginpunt. Zoek de gewenste graden op de buitenrand. Zet daar een punt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_tekenen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Om een hoek van 60° te tekenen, zoek je de 60° markering op de geodriehoek en zet je daar een punt. Verbind dat punt met het beginpunt om het tweede been te tekenen. Onthoud: lees altijd de schaal af die bij 0° begint aan de kant van je eerste been.",
        "solutionSteps": [
          "Leg de geodriehoek met het nulpunt op het beginpunt",
          "Zoek 60° op de buitenrand",
          "Zet een punt bij 60°",
          "Verbind het beginpunt met het punt"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij 60° op de geodriehoek.",
          "1": "Je dacht waarschijnlijk dat je de aanvullende hoek moet gebruiken (180° − 60° = 120°). Maar je leest gewoon 60° af op de schaal.",
          "2": "Je dacht waarschijnlijk dat 60° de helft is van 30°. Maar het is andersom: 30° is de helft van 60°. Lees de graden direct af.",
          "3": "Je dacht waarschijnlijk aan een rechte hoek. Maar 90° is een rechte hoek, en 60° is kleiner (een scherpe hoek)."
        }
      }
    },
    {
      "id": "MET-HOEK-TEKENEN-002",
      "familyId": "MET-HOEK-TEKENEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_tekenen",
      "questionType": "multiple_choice",
      "question": "Je wilt een hoek van 150° tekenen. Je ziet op de geodriehoek zowel 150° als 30° op dezelfde plek staan. Welk getal gebruik je?",
      "options": ["Het maakt niet uit", "30°, want dat is het kleinste getal", "150°, want de hoek is stomp (groter dan 90°)", "Geen van beide — je moet twee keer 75° tekenen"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stompe hoek tekenen",
            "content": "Bij een stompe hoek (> 90°) kies je het grotere getal op de geodriehoek. 150° is stomp, dus je leest 150° af. 30° zou een scherpe hoek opleveren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_tekenen_stomp",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Je wilt 150° tekenen. Dat is een stompe hoek (groter dan 90°). Op de geodriehoek staan 150° en 30° op dezelfde plek (want 150° + 30° = 180°). Omdat je een stompe hoek wilt, kies je 150°. Als je 30° zou kiezen, teken je een scherpe hoek — dat is niet wat je wilt. Onthoud: schat eerst of je hoek scherp of stomp is, en kies dan de juiste schaal.",
        "solutionSteps": [
          "150° > 90° → stompe hoek",
          "Op de geodriehoek: 150° en 30° staan op dezelfde plek",
          "Kies 150° (de stompe waarde)",
          "Check: 150° + 30° = 180° (aanvullende hoeken)"
        ],
        "distractorExplanations": {
          "0": "Het maakt wél uit! 150° en 30° zijn heel verschillende hoeken. Als je 30° tekent in plaats van 150°, is je hoek veel te klein.",
          "1": "Je dacht waarschijnlijk dat je altijd het kleinste getal kiest. Maar 30° is een scherpe hoek, en je wilt 150° (stomp). Onthoud: kies het getal dat past bij het type hoek dat je wilt tekenen.",
          "2": "Goed! 150° is stomp, dus je kiest het grotere getal op de geodriehoek.",
          "3": "Je dacht waarschijnlijk dat je twee hoeken moet combineren. Maar je tekent één hoek van 150° in één keer. Onthoud: lees het juiste getal af op de geodriehoek."
        }
      }
    },
    {
      "id": "MET-HOEK-TEKENEN-003",
      "familyId": "MET-HOEK-TEKENEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_tekenen",
      "questionType": "ordering",
      "question": "Zet de stappen voor het tekenen van een hoek met een geodriehoek in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Teken een rechte lijn (het eerste been)",
          "Leg de geodriehoek met het nulpunt op het beginpunt van de lijn",
          "Zet een punt bij de gewenste graden op de boog",
          "Verbind het beginpunt met het punt (het tweede been)"
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappen hoek tekenen",
            "content": "1. Teken een rechte lijn (eerste been). 2. Leg de geodriehoek met nulpunt op het beginpunt. 3. Zet een punt bij de gewenste graden. 4. Verbind beginpunt met het punt (tweede been).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_tekenen_stappen",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De juiste volgorde is: 1) Teken een rechte lijn — dit wordt het eerste been. 2) Leg de geodriehoek met het nulpunt op het beginpunt — zo weet je waar je meet. 3) Zet een punt bij de gewenste graden — dit markeert de richting van het tweede been. 4) Verbind het beginpunt met het punt — nu heb je twee benen en een hoek. Onthoud: lijn → geodriehoek → punt → verbinden.",
        "solutionSteps": [
          "Stap 1: Teken een rechte lijn (eerste been)",
          "Stap 2: Leg geodriehoek met nulpunt op beginpunt",
          "Stap 3: Zet punt bij gewenste graden",
          "Stap 4: Verbind beginpunt met punt (tweede been)"
        ]
      }
    },
    {
      "id": "MET-HOEK-TEKENEN-004",
      "familyId": "MET-HOEK-TEKENEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_tekenen",
      "questionType": "multiple_choice",
      "question": "Je moet een hoek van 45° tekenen. De geodriehoek heeft twee schalen (binnenrand en buitenrand). Je leest af op de buitenrand en ziet 45° en 135°. Welk getal gebruik je?",
      "options": ["Geen van beide — je moet de binnenrand gebruiken", "135°", "Het maakt niet uit", "45°"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee schalen op de geodriehoek",
            "content": "De geodriehoek heeft twee schalen die samen 180° maken. Kies altijd de schaal die bij 0° begint aan de kant van je eerste been.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_tekenen_schaal",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Je wilt 45° tekenen, dus je leest 45° af. De 135° is de aanvullende hoek (45° + 135° = 180°). Gebruik altijd de schaal die begint bij 0° aan de kant van je lijn.",
        "solutionSteps": [
          "Je wilt 45° tekenen",
          "Kies de schaal die bij 0° begint aan je lijn",
          "Lees 45° af op die schaal",
          "Let op: 135° is de andere schaal (45° + 135° = 180°)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de binnenrand moet gebruiken. Maar het hangt af van welke schaal bij 0° begint aan de kant van je lijn.",
          "1": "Je dacht waarschijnlijk dat je 135° moet gebruiken. Maar 135° is de aanvullende hoek op de andere schaal. Je wilt 45°, dus lees 45° af.",
          "2": "Je dacht waarschijnlijk dat het niet uitmaakt. Maar als je 135° afleest in plaats van 45°, teken je een stompe hoek in plaats van een scherpe hoek.",
          "3": "Goed! Je leest 45° af op de schaal die bij 0° begint."
        }
      }
    },
    {
      "id": "MET-HOEK-TEKENEN-005",
      "familyId": "MET-HOEK-TEKENEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_tekenen",
      "questionType": "fill_in",
      "question": "Je tekent een hoek van 72°. Op de geodriehoek staat ook de aanvullende hoek (samen 180°). Hoeveel graden staat er naast de 72°? Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["108", "108°"],
        "caseSensitive": false,
        "placeholder": "...°"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aanvullende hoeken",
            "content": "Twee aanvullende hoeken zijn samen 180°. Dus: 180° − 72° = 108°. Op de geodriehoek staan deze twee getallen altijd naast elkaar.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hoek_tekenen_aanvullend",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Aanvullende hoeken zijn samen 180°. Dus: 180° − 72° = 108°. Op de geodriehoek staan 72° en 108° op dezelfde plek maar op verschillende schalen. Onthoud: aanvullend = samen 180°. Controleer: 72° + 108° = 180° ✓.",
        "solutionSteps": [
          "Aanvullende hoeken: samen 180°",
          "180° − 72° = 108°",
          "Check: 72° + 108° = 180° ✓"
        ]
      }
    }
  ]
}